import { useCallback, useState } from 'react'
import { createCommentSubmit } from 'common/Prose/Prompts/CreateCommentPrompt/createCommentSubmit'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { getInitials, ourUuid } from 'utils'
import Styles from './CommentInput.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Send2 } from 'blaze-ui/icons/16'
import { useAuth } from 'hooks/UseAuth'
import Avatar from 'common/Avatar/Avatar'
import { EditorView } from 'prosemirror-view'

interface Props {
  onSuccess?: () => void
  view?: EditorView
  commentable_id?: number
}

export const CommentInput = observer(({ onSuccess, view, commentable_id }: Props) => {
  const docStore = useDocStore()
  const auth = useAuth()
  const [comment, setComment] = useState<string>('')
  const close = useCallback(() => {
    onSuccess?.()
    view?.focus()
  }, [onSuccess, view])

  if (!view) return null

  const handleSubmitReply = async () => {
    if (!commentable_id) return

    docStore.rootStore.comments.create({ comment, commentable_id, commentable_type: 'Comment' }, [], true)
  }

  const handleSubmitComment = createCommentSubmit(view, docStore.layerId || '', docStore, true, ourUuid(), close)

  return (
    <div className={Styles.newComment}>
      <Avatar url={auth?.avatar} label={getInitials(auth?.display_name)} size={24} />
      <Input
        name="comment"
        onChange={(e) => setComment(e.target.value)}
        placeholder="Add a new comment"
        value={comment}
        size="lg"
        className={Styles.input}
        autoFocus
      />
      <IconButton
        icon={Send2}
        isDisabled={!comment}
        onPress={() => {
          if (commentable_id) {
            handleSubmitReply()
          } else {
            handleSubmitComment(comment, [])
          }
          setComment('')
        }}
      />
    </div>
  )
})
